import React from "react";
import PageTemplate from "../components/PageTemplate";
import CheckoutMobileHeader from "../components/checkout/CheckoutMobileHeader";
import CheckoutBody from "../components/checkout/CheckoutBody";
import {useLocation} from "react-router-dom";

const Checkout = () => {
  const query = new URLSearchParams(useLocation().search);

  if (query.get('coupon')) {
    sessionStorage.setItem('coupon', query.get('coupon'));
  }

  return (
    <PageTemplate
      title="Checkout"
      sidebarTitle="Checkout"
      sidebarSubtitle="Just add a card and confirm your new plan."
      mobileHeader={<CheckoutMobileHeader />}
      centered
    >
      <CheckoutBody />
    </PageTemplate>
  );
};

export default Checkout;
